import { render, staticRenderFns } from "./AppUploadDocumentos.vue?vue&type=template&id=a282be3a&scoped=true&lang=pug&"
import script from "./AppUploadDocumentos.vue?vue&type=script&lang=js&"
export * from "./AppUploadDocumentos.vue?vue&type=script&lang=js&"
import style0 from "./AppUploadDocumentos.vue?vue&type=style&index=0&id=a282be3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a282be3a",
  null
  
)

export default component.exports